import { createContext, useContext } from 'react';

const TabContext = createContext({ tabId: null, tabLabel: null});

export const TabProvider = ({ tabId, tabLabel, children }) => {
  return (
    <TabContext.Provider value={{ tabId, tabLabel }}>
      {children}
    </TabContext.Provider>
  );
};

export const useTab = () => useContext(TabContext);

export default TabContext;
